var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.6893 8.81411C34.8886 8.81411 36.6715 7.03119 36.6715 4.83186C36.6715 2.63252 34.8886 0.849609 32.6893 0.849609C30.4899 0.849609 28.707 2.63252 28.707 4.83186C28.707 7.03119 30.4899 8.81411 32.6893 8.81411Z",
    fill: "#AB3B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.5491 32.94C31.8811 33.0783 32.2373 33.1495 32.597 33.1495C32.9568 33.1495 33.3129 33.0783 33.645 32.94C34.1006 32.7594 34.4681 32.4086 34.6697 31.9619V31.7988L42.0985 13.9835C42.0985 13.9835 43.6355 10.4437 39.7697 11.4451C37.4531 12.5785 34.9082 13.1677 32.3292 13.1677C29.7502 13.1677 27.2053 12.5785 24.8887 11.4451L24.5859 11.3287C24.0037 11.1424 22.2571 10.8164 22.6298 13.3082V13.5643L30.1984 31.9153L30.4312 32.3345C30.7146 32.6695 31.1136 32.8857 31.5491 32.94Z",
    fill: "#AB3B77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.89241 8.81411C12.0917 8.81411 13.8747 7.03119 13.8747 4.83186C13.8747 2.63252 12.0917 0.849609 9.89241 0.849609C7.69307 0.849609 5.91016 2.63252 5.91016 4.83186C5.91016 7.03119 7.69307 8.81411 9.89241 8.81411Z",
    fill: "#1E2DBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.8227 11.235C10.4906 11.0966 10.1344 11.0254 9.7747 11.0254C9.41496 11.0254 9.0588 11.0966 8.72674 11.235C8.28246 11.4245 7.92522 11.7734 7.72535 12.2131V12.3761L0.319766 30.1914C0.319766 30.1914 -1.24053 33.7312 2.53213 32.7531C4.85179 31.616 7.40091 31.0248 9.98429 31.0248C12.5677 31.0248 15.1168 31.616 17.4365 32.7531L17.7159 32.8928C18.2981 33.0559 20.1611 33.3819 19.6954 30.8901C19.705 30.8049 19.705 30.719 19.6954 30.6339L12.1268 12.2829C12.0581 12.1384 11.9803 11.9984 11.8939 11.8638C11.7679 11.6912 11.6078 11.5463 11.4235 11.4382C11.2393 11.33 11.0348 11.2609 10.8227 11.235Z",
    fill: "#1E2DBE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ac8764affefff5de1a87982c539cf5ba.svg";
export { ForwardRef as ReactComponent };